import React, {useState, useEffect} from 'react';
import {labels} from '../../../util/utils';
import Modal from '../Modal/Modal';
import {useDispatch, useSelector} from 'react-redux';
import {deleteFlowchartStep} from '../../../actions/FlowChart/flowchartstepactions';
import {useEngagementId, useDocumentId} from '../../../util/customHooks';
import {getFlowChart} from '../../../actions/FlowChart/flowchartactions';
import Toast from '../BaseComponentWrappers/MotifToast';
import {clearErrors} from '../../../actions/erroractions';
import styled from 'styled-components';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import ProgressBar from '../BaseComponentWrappers/MotifProgressBar';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import {setIsModalOpen, setModalLevel} from '../../../actions/setismodalopen';

function DeleteStepModal(props) {
	const dispatch = useDispatch();
	const engagementId = useEngagementId();
	const documentId = useDocumentId();

	const flowChart = useSelector((state) => state.flowChart);
	const [showDeleteModel, setShowDeleteModel] = [props.showDeleteModel, props.setShowDeleteModel];
	const [isLoading, setIsLoading] = useState(false);

	let step = flowChart?.data[0]?.flowchartSteps?.find((step) => step.flowchartStepGuid === props.stepGuid);

	useEffect(() => {
		dispatch(clearErrors());
		dispatch(setFormV2ToasterVisibility(false));
		return () => {
			dispatch(setIsModalOpen(true));
		};
	}, []);

	const [toastConfig, setToastConfig] = useState({
		isToastVisiible: false,
		toastMessage: '',
		toastMessageType: ''
	});

	const resetToastConfig = () => {
		setToastConfig({
			isToastVisiible: false,
			toastMessage: '',
			toastMessageType: ''
		});
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			resetToastConfig();
		}, 3000);

		return () => clearTimeout(timer);
	}, [toastConfig.isToastVisiible]);

	const onCloseDeleteModal = () => {
		setShowDeleteModel(false);
		setIsLoading(false);
	};

	const onDeleteStepHandler = () => {
		setIsLoading(true);
		dispatch(deleteFlowchartStep(engagementId, flowChart?.data[0]?.id, step?.id))
			.then(() => {
				dispatch(
					getFlowChart(
						engagementId,
						{
							documentId: documentId,
							formBodyId: flowChart?.data[0]?.formBodyId,
							includeRelatedSteps: true,
							includeStepRelatedObjects: true
						},
						[]
					)
				).then(() => {
					onCloseDeleteModal();
				});
			})

			.catch(() => {
				setIsLoading(false);
				dispatch(clearErrors());
				setToastConfig({
					isToastVisiible: true,
					toastMessage: labels.flowChartNewSteps.deleteStepFailMessage,
					toastMessageType: ToastMessageVariants.Error
				});
			});
	};

	return (
		<>
			{toastConfig.isToastVisiible && (
				<StyledMotifToast
					variant={toastConfig.toastMessageType}
					className="toast-banner"
					onClose={() => {
						resetToastConfig();
					}}
					children={toastConfig.toastMessage}
				/>
			)}
			{showDeleteModel && (
				<Modal
					show={showDeleteModel}
					title={labels.flowChartStepsDelete.deletestep}
					closeTitle={labels.modalCancelTitle}
					modalContainerClass="deleteflowchartstep-modal"
					modalsize={'x-small'}
					showButtons
					confirmBtnTitle={labels.delete}
					closeBtnTitle={labels.modalCancelTitle}
					onOkClick={onDeleteStepHandler}
					onHide={onCloseDeleteModal}
					modalonmodal
					isCancelButtonDisabled={isLoading}
					isOkButtonDisabled={isLoading}
				>
					<StyledDescription className="StyledDescription">
						{isLoading ? (
							<section className="loaderparent">
								<section className="MotifProgressBarWrapper">
									<ProgressBar isIndeterminate circle hideLabel />
								</section>
							</section>
						) : (
							<section>
								<section className="titlelabel motif-body1-default-light">{labels.flowChartStepsDelete.deleteStepModalMessage}</section>
								<section className="titlevalue motif-label2-default-regular">
									<EllipsesControl content={step.flowchartStepName} tooltip={step.flowchartStepName} noOfLines={3} />
								</section>
							</section>
						)}
					</StyledDescription>
				</Modal>
			)}
		</>
	);
}

export default DeleteStepModal;

const StyledMotifToast = styled(Toast)`
	&.toast-banner {
		margin-bottom: var(--px-10);
	}
`;

const StyledDescription = styled.section`
	.MotifProgressBarWrapper {
		padding: var(--px-25) 0;
		.motif-progress-bar-wrapper {
			width: var(--px-32);
			margin: 0 auto;
		}
	}
	.titlelabel {
		color: var(--neutrals-900);
		padding-bottom: var(--spacing-x-large);
		border-bottom: var(--border-width-small) solid var(--neutrals-100);
	}
	.titlevalue {
		color: var(--neutrals-900);
		padding-top: var(--spacing-x-large);
	}
`;
